import { ControllerSubject } from "../components/Subject";

export default class ModuleController {
    constructor() {
        this.subject = new ControllerSubject();
    }

    getSubject() {
        return this.subject
    }

    // Adds an observer to the subject
    addObserver(observer=false) {
        if ( observer ) {
            this.subject.addObserver(observer);
        }
    }
}